const UPDATE_MODEL_EVENT = 'update:modelValue'
const CHANGE_EVENT = 'change'
const BLUR_EVENT = 'blur'
const INPUT_EVENT = 'input'
const FOCUS_EVENT = 'focus'
const SCROLL_EVENT = 'scroll'

export { UPDATE_MODEL_EVENT, CHANGE_EVENT, BLUR_EVENT, INPUT_EVENT, FOCUS_EVENT, SCROLL_EVENT }

const ON_CHANGE_EVENT = 'onChange'
const ON_BLUR_EVENT = 'onBlur'
const ON_FOCUS_EVENT = 'onFocus'

export { ON_CHANGE_EVENT, ON_BLUR_EVENT, ON_FOCUS_EVENT }

export const VALIDATE_STATE_MAP = {
  validating: 'el-icon-loading',
  success: 'el-icon-circle-check',
  error: 'el-icon-circle-close'
}

export const REGEX = {
  PhoneNumber: /^(0?)(3[2-9]|5[6|8|9]|7[0|6-9]|8[0-6|8|9]|9[0-4|6-9])[0-9]{7}$/
}
